import classnames from "classnames";
import get from "lodash-es/get";
import React, { FC, memo } from "react";

import { testAttr } from "@/browser";

import { flexAlignClass, flexJustifyClass } from "../../../Style";
import { IColumnConfig } from "../../types";
import { getColumnStyle } from "../../utils";

export interface IRowCellComponentProps<T = any> {
  className?: string;
  column: IColumnConfig<T>;
  rowData: T;
  rowIndex: number;
  [key: string]: unknown;
}

const RowCellComponentBase: FC<IRowCellComponentProps> = ({ rowData, column, className, rowIndex, ...rest }) => {
  const { CellComponent, align = "center", justify = "flex-start" } = column;
  const cellTestableProps = testAttr(column, { sufix: "data-table__cell" });

  const style = getColumnStyle(column);

  const classNames = classnames(
    "data-table__cell",
    column.className,
    flexAlignClass(align),
    flexJustifyClass(justify),
    className,
  );

  const value = column.selector
    ? column.selector(rowData, column)
    : column.accessor
    ? get(rowData, column.accessor)
    : undefined;

  return (
    <div style={style} className={classNames} {...cellTestableProps}>
      {CellComponent ? (
        <CellComponent rowData={rowData} value={value} column={column} rowIndex={rowIndex} {...rest} />
      ) : (
        value
      )}
    </div>
  );
};

export const RowCellComponent = memo(RowCellComponentBase);
